import { BROWSER } from '@ezugi/constants';

import { DeviceInfo } from './deviceInfo';

export const getBrowser = () => {
  const { CHROME, SAFARI, EXPLORER, EDGE, FIREFOX, OPERA, UNKNOWN } = BROWSER;

  return (
    (DeviceInfo.isChrome && CHROME)
    || (DeviceInfo.isSafari && SAFARI)
    || (DeviceInfo.isInternetExplorer && EXPLORER)
    || (DeviceInfo.isMsEdge && EDGE)
    || (DeviceInfo.isFirefox && FIREFOX)
    || (DeviceInfo.isOpera && OPERA)
    || UNKNOWN
  );
};
